export const formatNumber = (number: string | number) => {
  if (typeof number === 'number') {
    const regEx = /(?=\d)(?=(\d{3})+(?!\d))/g;
    return number.toString().replace(regEx, ' ');
  } else return number;
};
